<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row :gutter="20" class="h-full">
      <el-col class="border-r-2px border-color-[#dbdbdb]-right border-solid h-full" :span="6">
        <div class="mb-10px border-l-2 border-color-primary pl-10px">
          数据标准库
        </div>
        <div class="flex w-full">
          <el-select
            v-model="standardId"
            filterable
            clearable
            placeholder="请选择标准库"
            size="small"
            @change="getParentTypeList"
            class="w-full"
          >
            <el-option
              v-for="item in standardList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="my-10px border-l-2 border-color-primary pl-10px flex items-center">
          <span class="flex-1 text-[#303133]">数据表选择</span>
          <el-dropdown>
            <span class="el-dropdown-link">
              <i class="iconfont icon-line-moreVertical text-14px font-bold text-[#606266]"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
              <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-row type="flex">
          <el-input
            placeholder="输入表名"
            class="mr-10px"
            size="small"
            clearable
            @keyup.enter.native="getParentTypeList"
            v-model="classKeyword"
          ></el-input>
          <el-button type="primary" size="small" @click="getParentTypeList">搜索</el-button>
        </el-row>
        <el-tree
          :data="tagTreeData"
          :props="classTreeProps"
          :load="loadClassTreeNode"
          :default-expand-all="defaultExpandAll"
          node-key="id"
          @node-click="handleNodeClick"
          lazy
          :check-strictly="true"
          :expand-on-click-node="false"
          :highlight-current="true"
          ref="tree"
          v-if="treeStandBy"
        >
          <div slot-scope="{ node, data }" class="w-[calc(100%-40px)] text-overflow relative">
            <el-tooltip
              :content="`${node.label}（${data.name}）`"
              placement="top"
              :disabled="isShowTooltip"
            >
              <span
                class="text-overflow mt-2px"
                :class="`treeTooltip${data.id}`"
                @mousemove="classTreeMouseOver(`treeTooltip${data.id}`)"
              >
                {{ node.label }}({{ data.name }})
              </span>
            </el-tooltip>
          </div>
        </el-tree>
      </el-col>
      <el-col class="h-full" :span="18" v-loading="spreadjsLoading">
        <div class="h-full w-full" id="gc-designer-box"></div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import StandardManagementService from '@/services/common/StandardManagementService'
import dayjs from 'dayjs'
import stdClassListService from '@/services/stdClassListService'
import defaultJson from './defaultJson'

export default {
  async created() {
    await this.getStandardList()
    this.getParentTypeList()
    await this.getEntityData()
  },
  mounted() {
    this.initSheet()
  },
  data() {
    return {
      isShowTooltip: false,
      classTreeProps: {
        label: 'code',
        children: 'children',
        isLeaf: (data) => {
          if (!data.isLeaf) {
            return true
          }
          return false
        },
      },
      classKeyword: '',
      tagTreeData: [],
      currentClassName: '',
      entityContent: '',
      saveSuceess: false,
      standardList: [],
      standardId: '',
      treeData: [],
      treeLoading: false, // 目录树loading
      defaultTreeProps: {
        label: 'name',
        children: 'childList',
        isLeaf: 'isLeaf',
      },
      defaultExpandIds: [], // 目录树默认展开节点
      treeStandBy: true, // 是否显目录树 用于刷新树
      spread: null,
      excelIo: null,
      sheet: null,
      designer: null,
      currentNode: null,
      columns: [], // 当前所有列信息
      userInfo: Wiz.AuthHooks.GetUserInfo(), // 登录用户信息
      currentTempData: null, // 当前实体暂存信息
      currentTempDataId: '', // 当前实体暂存信息id
      nodeClick: false,
      defaultExpandAll: false, // 是否默认展开所有节点
      spreadjsLoading: false, // spreadjs操作时的loading
      tableFieldList: [], // 字段列表数据
      defineParasList: [], // 需要实时请求接口的枚举规则
    }
  },
  methods: {
    // 列表转树
    listToTree(list) {
      // 先找出所有有效的父节点ID
      const parentIds = new Set(
        list.map((item) => {
          return item.id
        })
      )

      const result = list.reduce((prev, curr) => {
        curr.pathName = `/${curr.name}/`
        curr.children = list.filter((v) => {
          return v.parentId === curr.id
        })

        // 如果是根节点或找不到父节点,就放到第一级
        if (
          curr.parentId === '00000000-0000-0000-0000-000000000000' ||
          curr.parentId === '' ||
          curr.parentId === null ||
          !parentIds.has(curr.parentId)
        ) {
          prev.push(curr)
        }
        return prev
      }, [])

      return result
    },
    // 获取对象类别列表
    async getParentTypeList() {
      const parameter = {
        standard_id: this.standardId,
        // data_type: 1,
        // approve_status: 1, // 已发布的实体
        // info_type: 0, // 对象
        // catecode: 'Tag', // 对象
        keyword: this.classKeyword,
        data_type: this.classKeyword ? 1 : 0,
      }
      const res = await stdClassListService.getClassList(parameter)
      console.log('对象类别列表', res)
      if (res && res.code === 0 && res.data) {
        this.tagTreeData = res.data.length > 0 ? this.listToTree(res.data) : []
        // this.searchTagClassIds = this.tagTreeData.map((item) => {
        //   return item.id
        // })
      }
    },
    async loadClassTreeNode(node, resolve) {
      const parameter = {
        standard_id: this.standardId,
        keyword: this.classKeyword,
        data_type: this.classKeyword ? 1 : 0,
        parent_id: node.data?.id,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        node.data.children = res.data
        return resolve(res.data)
      }
      return resolve([])
    },
    handleChildren(childList, data, parentId) {
      childList.map((item) => {
        if (item.id === parentId) {
          item.children = data
        } else if (item.id !== parentId && item.children) {
          this.handleChildren(item.children, data, parentId)
        }
        return item
      })
    },
    /**
     * @description 目录树展开或收起
     * @param {Boolean} bool 是否展开全部
     */
    operateTree(bool) {
      this.defaultExpandIds = this.$options.data().defaultExpandIds
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    /**
     * @description 提交审核
     */
    async dataBatchSubmit() {
      const param = Object.keys(this.sheet.getDataSource().getSource())
      const res = await StandardManagementService.dataBatchSubmit({ classes: param })
      if (res && res.code === 0) {
        this.$message.success('操作成功')
      }
    },

    /**
     * @description 保存表格数据
     */
    async insertCollectData() {
      // if (this.saveSuceess) {
      //   this.$message.warning('重复保存')
      //   return
      // }
      if (!this.currentNode?.id) return
      this.sheet = this.spread.getActiveSheet()
      const sourceData = this.restoreHeaders()
      const param = {
        data: JSON.stringify(sourceData),
        templateId: this.currentTempDataId || null,
        classId: this.currentNode.id,
      }
      this.spreadjsLoading = true
      const res = await StandardManagementService.insertCollectData(param)
      this.spreadjsLoading = false
      if (res && res.code === 0) {
        if (!res.data.length) {
          this.saveSuceess = true
          // this.dataBatchSubmit()
          this.$message.success('成功')
        } else {
          // _.forEach(res.data, (i) => {
          //   this.$message.error(i)
          // })
          this.$message.error(res.data.join(','))
        }
      }
    },

    /**
     * @description 单元格表头修改过的数据还原
     * @returns {Object} 修改后的提交数据
     */
    restoreHeaders() {
      const sourceData = _.cloneDeep(this.sheet.getDataSource().getSource())
      for (const key in sourceData) {
        if (Array.isArray(sourceData[key]) && sourceData[key].length) {
          sourceData[key] = sourceData[key].filter((item) => {
            let isEmpty = true
            for (const childKey in item) {
              if (item[childKey]) {
                isEmpty = false
              }
            }
            if (!isEmpty) {
              return item
            }
          })
        } else if (!Array.isArray(sourceData[key])) {
          sourceData[key] = [sourceData[key]]
        }
      }
      const spreadJson = this.spread.toJSON()
      const sheetsKeys = Object.keys(spreadJson.sheets)
      if (!sheetsKeys.length) return sourceData
      const tables = spreadJson.sheets[sheetsKeys[0]].tables // 新建的表
      _.forEach(tables, (table) => {
        const source = sourceData[table.bindingPath][0]
        _.forEach(table.columns, (column) => {
          if (column.dataField !== column.name) {
            // 字段表头存在修改,删除添加的多余的字段表头(修改后添加的)
            Reflect.deleteProperty(source, column.name)
          }
        })
      })
      return sourceData
    },

    /**
     * @description 表格必填项校验
     * @returns {Boolean} 数据是否全部校验通过
     */
    validCell() {
      this.spread.options.highlightInvalidData = true
      const dataSource = this.sheet.getDataSource().getSource() // 表格所有数据(包括表头)

      const headerNameList = [...defaultJson.sheets.Sheet1.tables[0].columns] // 表头name list

      const notFilledFileds = new Set() // 有必填项未填写的字段
      // 获取每列对应的校验
      _.forEach(headerNameList, (headerItem) => {
        const columnItem = _.find(this.columns, (column) => {
          return column.name === headerItem.name
        })
        if (columnItem && columnItem.isNullable) {
          const valueList = Object.values(dataSource)
          _.forEach(valueList[0], (item) => {
            if (!item[columnItem.name]) {
              notFilledFileds.add(columnItem.name)
            }
          })
        }
      })
      return [...notFilledFileds]
    },

    /**
     * @description 添加校验提示语
     * @param {Number} rowIndex 横坐标
     * @param {Number} colIndex 纵坐标
     * @param {String} tipText 提示语
     * @param {Boolean} isRequired 是否必填
     * @param {Boolean} isLengthLimit 是否有字符长度限制
     * @param {Number} limitLength 字符长度限制数
     */
    addValidTip(rowIndex, colIndex, tipText, isRequired, isLengthLimit, limitLength) {
      this.spread.options.highlightInvalidData = true
      let dv
      if (isLengthLimit) {
        dv = GC.Spread.Sheets.DataValidation.createTextLengthValidator(
          GC.Spread.Sheets.ConditionalFormatting.ComparisonOperators.lessThan,
          `${limitLength}`
        )
      } else if (isRequired) {
        dv = GC.Spread.Sheets.DataValidation.createTextLengthValidator(
          GC.Spread.Sheets.ConditionalFormatting.ComparisonOperators.greaterThan,
          '0'
        )
      }
      dv.showInputMessage(true)
      // dv.inputMessage(`该字段为必填项,且字符串最大长度不超过${columnItem.length}`)
      dv.inputMessage(tipText)
      dv.showErrorMessage(false)
      dv.highlightStyle({
        type: GC.Spread.Sheets.DataValidation.HighlightType.dogEar,
        color: 'red',
        position: GC.Spread.Sheets.DataValidation.HighlightPosition.topRight,
      })
      this.sheet.setDataValidator(rowIndex, colIndex, 1, 1, dv, GC.Spread.Sheets.SheetArea.viewport)
    },

    /**
     * @description 初始化数据源
     */
    initDataSource() {
      const jsonData = this.spread.toJSON()
      console.log(jsonData, 'jsonData')
      const dataObject = {}
      const tableObject = {}
      if (!this.currentTempDataId || this.nodeClick) {
        _.forEach(jsonData.sheets.Sheet1.tables, (item) => {
          dataObject[item.bindingPath] = []
          _.forEach(item.columns, (tableColumn) => {
            if (tableObject[item.bindingPath]) {
              tableObject[item.bindingPath][tableColumn.dataField] = ''
            } else {
              tableObject[item.bindingPath] = {
                [tableColumn.dataField]: '',
              }
            }
          })
        })
      }
      console.log(dataObject, tableObject, 'dataObject')
      const sourceData = this.currentTempData ? this.currentTempData : dataObject
      if (_.isNil(this.currentTempData)) {
        for (let i = 0; i < 99; i += 1) {
          for (const z in tableObject) {
            for (const key in dataObject) {
              if (z === key) {
                dataObject[key].push(_.cloneDeep(tableObject[z]))
              }
            }
          }
        }
      } else {
        console.log(this.currentTempData, 'this.currentTempData')
        let isInitTemplate = false
        let savedDataLength = 0 // 暂存过的数据量
        for (const key in this.currentTempData) {
          if (this.currentTempData[key].length === 99) {
            isInitTemplate = true
          } else {
            savedDataLength = this.currentTempData[key].length
          }
        }
        if (!isInitTemplate) {
          // 兼容旧数据初始化不是100的
          for (let i = 0; i < savedDataLength; i += 1) {
            for (const key in dataObject) {
              dataObject[key][i] = this.currentTempData[key][i]
            }
          }
          for (let i = savedDataLength; i < 99; i += 1) {
            for (const z in tableObject) {
              for (const key in dataObject) {
                if (z === key) {
                  dataObject[key].push(_.cloneDeep(tableObject[z]))
                }
              }
            }
          }
        }
        // for (let i = 0; i < 99; i += 1) {
        //   if (this.currentTempData[this.currentClassName].length > i) {
        //     jsonData.sheets.Sheet1.tables.forEach((tableItem) => {
        //       for (let z = 0; z < tableItem.columns.length; z += 1) {
        //         sourceData[this.currentClassName][i][
        //           tableItem.columns[z].dataField
        //         ] = this.currentTempData[this.currentClassName][i][tableItem.columns[z].dataField]
        //       }
        //     })
        //   } else {
        //     const obj = {}
        //     jsonData.sheets.Sheet1.tables.forEach((tableItem) => {
        //       for (let z = 0; z < tableItem.columns.length; z += 1) {
        //         obj[tableItem.columns[z].dataField] = ''
        //       }
        //     })
        //     sourceData[this.currentClassName].push(obj)
        //   }
        // }
      }

      console.log(sourceData, 'sour33ceData')
      if (!this.currentNode.templateId) {
        this.spread.suspendPaint()
      }
      this.sheet = this.spread.getActiveSheet()
      const source = new GC.Spread.Sheets.Bindings.CellBindingSource(sourceData)
      console.log(source, 'source')

      this.sheet.setDataSource(source)

      if (!this.currentNode.templateId) {
        this.spread.resumePaint()
        this.$nextTick(() => {
          const sheet = this.spread.getActiveSheet()
          const sheetsKeys = Object.keys(jsonData.sheets)
          if (!sheetsKeys.length) return
          // 列宽自适应
          this.spread.suspendPaint()
          const columnCount = jsonData.sheets[sheetsKeys[0]]?.columnCount
          if (columnCount && sheet) {
            for (let i = 0; i < columnCount; i += 1) {
              sheet.autoFitColumn(i)
            }
          }
          const rowTable = jsonData.sheets[sheetsKeys[0]]?.data?.dataTable
          if (rowTable && sheet) {
            const rowCountList = Object.keys(rowTable)
            if (rowCountList) {
              const rowCount = rowCountList[rowCountList.length - 1]
              for (let i = 0; i < rowCount; i += 1) {
                sheet.autoFitRow(i)
              }
            }
          }
          this.spread.resumePaint()
        })
      }
    },

    /**
     * @description 获取实体属性树
     */
    async getEntityData() {
      const res = await StandardManagementService.getEntityTree({
        standardId: this.$route.query.standardId,
      })
      if (res && res.data && res.code === 0) {
        this.tableFieldList = [...res.data]
      }
    },

    /**
     * @description 添加字段规则
     */
    async addFieldRuleByTable(contextJson) {
      const spreadJson = contextJson
      const sheetsKeys = Object.keys(spreadJson.sheets)
      if (!sheetsKeys.length) return
      spreadJson.highlightInvalidData = true // 开启无效数据高亮
      const tables = spreadJson.sheets[sheetsKeys[0]].tables // 新建的表
      const validations = spreadJson.sheets[sheetsKeys[0]].validations || [] // 用户手动添加的校验规则
      const addValidations = [] // 需要添加的校验规则
      const enumList = []

      // 循环字段，设置规则
      _.forEach(tables, (table) => {
        const columns = table.columns // 该表下的字段
        const fieldRules = _.find(this.tableFieldList, (tableFile) => {
          return table.bindingPath === tableFile.className
        }) // 该表下的所有字段规则
        if (!fieldRules) return
        _.forEach(columns, async (column, colIndex) => {
          const rule = _.find(fieldRules.attributeList, (fieleRule) => {
            return column.name === fieleRule.attributeName
          }) // 该字段规则
          if (rule) {
            // 需要校验的规则 isNullable：必填 valueType === 1：字符长度限制 valueType === 2：整数 columnItem.valueType === 3：小数
            if (!validations.length) {
              if (rule.isNullable) {
                if (rule.valueType === 1) {
                  addValidations.push(
                    this.getExcelRule(table.row + 1, table.col + colIndex, 5, rule.length)
                  )
                } else {
                  addValidations.push(this.getExcelRule(table.row + 1, table.col + colIndex, 1))
                }
              } else if (rule.valueType === 1) {
                addValidations.push(
                  this.getExcelRule(table.row + 1, table.col + colIndex, 4, rule.length)
                )
              } else if (rule.valueType === 2) {
                addValidations.push(this.getExcelRule(table.row + 1, table.col + colIndex, 2))
              } else if (rule.valueType === 3) {
                addValidations.push(this.getExcelRule(table.row + 1, table.col + colIndex, 3))
              } else if (rule.valueType === 6) {
                column.dataStyle = {
                  borderBottom: { color: '#7bafdd', style: 1 },
                  borderTop: { color: '#7bafdd', style: 1 },
                  formatter: 'YYYY-MM-DD hh:mm:ss',
                }
              } else if (rule.valueType === 8) {
                column.dataStyle = {
                  borderBottom: { color: '#7bafdd', style: 1 },
                  borderTop: { color: '#7bafdd', style: 1 },
                  formatter: 'yyyy-mm-dd;@',
                }
              } else if (rule.valueType === 9) {
                column.dataStyle = {
                  borderBottom: { color: '#7bafdd', style: 1 },
                  borderTop: { color: '#7bafdd', style: 1 },
                  formatter: 'h:mm:ss;@',
                }
              }
              if (rule.referenceDataClassId) {
                // 枚举数据限制
                enumList.push(
                  (async () => {
                    this.spreadjsLoading = true
                    const res = await StandardManagementService.getDataItem({
                      SkipCount: 0,
                      MaxResultCount: 99,
                      cateId: rule.referenceDataClassId,
                    })
                    this.spreadjsLoading = false
                    if (res && res.data && res.code === 0) {
                      const sheet = this.spread.getActiveSheet()
                      const cellRule = this.getExcelRule(
                        table.row + 1,
                        table.col + colIndex,
                        6,
                        0,
                        _.map(res.data, 'name').join(','),
                        sheet.getRowCount() - 1
                      )
                      addValidations.push(cellRule)
                      this.defineParasList.push({
                        ...cellRule,
                        searchQuery: {
                          cateId: rule.referenceDataClassId,
                        }, // 数据字典查询条件
                      })
                    }
                  })()
                )
              }
            } else {
              const validItem = _.find(validations, (validation) => {
                if (validation?.condition?.ranges) {
                  return _.find(validation.condition.ranges, (range) => {
                    return range.row === table.row + 1 && range.col === table.col + colIndex
                  })
                }
                return false
              }) // 该单元格是否已存在校验规则
              if (!validItem) {
                if (rule.isNullable) {
                  if (rule.valueType === 1) {
                    addValidations.push(
                      this.getExcelRule(table.row + 1, table.col + colIndex, 5, rule.length)
                    )
                  } else {
                    addValidations.push(this.getExcelRule(table.row + 1, table.col + colIndex, 1))
                  }
                } else if (rule.valueType === 1) {
                  addValidations.push(
                    this.getExcelRule(table.row + 1, table.col + colIndex, 4, rule.length)
                  )
                } else if (rule.valueType === 2) {
                  addValidations.push(this.getExcelRule(table.row + 1, table.col + colIndex, 2))
                } else if (rule.valueType === 3) {
                  addValidations.push(this.getExcelRule(table.row + 1, table.col + colIndex, 3))
                } else if (rule.valueType === 6) {
                  column.dataStyle = {
                    borderBottom: { color: '#7bafdd', style: 1 },
                    borderTop: { color: '#7bafdd', style: 1 },
                    formatter: 'YYYY-MM-DD hh:mm:ss',
                  }
                } else if (rule.valueType === 8) {
                  column.dataStyle = {
                    borderBottom: { color: '#7bafdd', style: 1 },
                    borderTop: { color: '#7bafdd', style: 1 },
                    formatter: 'yyyy-mm-dd;@',
                  }
                } else if (rule.valueType === 9) {
                  column.dataStyle = {
                    borderBottom: { color: '#7bafdd', style: 1 },
                    borderTop: { color: '#7bafdd', style: 1 },
                    formatter: 'h:mm:ss;@',
                  }
                }
                if (rule.referenceDataClassId) {
                  // 枚举数据限制
                  enumList.push(
                    (async () => {
                      this.spreadjsLoading = true
                      const res = await StandardManagementService.getDataItem({
                        SkipCount: 0,
                        MaxResultCount: 99,
                        cateId: rule.referenceDataClassId,
                      })
                      this.spreadjsLoading = false
                      if (res && res.data && res.code === 0) {
                        const sheet = this.spread.getActiveSheet()
                        const cellRule = this.getExcelRule(
                          table.row + 1,
                          table.col + colIndex,
                          6,
                          0,
                          _.map(res.data, 'name').join(','),
                          sheet.getRowCount() - 1
                        )
                        addValidations.push(cellRule)
                        this.defineParasList.push({
                          ...cellRule,
                          searchQuery: {
                            cateId: rule.referenceDataClassId,
                          }, // 数据字典查询条件
                        })
                      }
                    })()
                  )
                }
              }
            }
          }
        })
      })
      await Promise.all(enumList)
      this.$nextTick(() => {
        spreadJson.sheets[sheetsKeys[0]].validations = [...validations, ...addValidations] // 合并校验规则

        // 枚举类型校验规则需要处理结束行索引
        const dealValidations = [...spreadJson.sheets[sheetsKeys[0]].validations]
        _.forEach(dealValidations, (validation) => {
          if (
            validation.type === 3 &&
            validation.condition.expected &&
            validation.condition.conType === 12
          ) {
            if (validation.condition?.ranges) {
              // 枚举类型校验规则
              const sameColumns = _.filter(dealValidations, (item) => {
                return (
                  item.condition.ranges[0].col === validation.condition.ranges[0].col &&
                  item.condition.ranges[0].row !== validation.condition.ranges[0].row
                )
              })
              if (sameColumns.length) {
                // 找到最近行索引
                const rowIndexs = _.map(sameColumns, (column) => {
                  return column.condition.ranges[0].row
                })
                rowIndexs.sort((a, b) => {
                  return a - b
                })
                validation.condition.ranges[0].rowCount =
                  rowIndexs[0] - (validation.condition.ranges[0].row + 1)
              }
            }
          }
        })
        spreadJson.sheets[sheetsKeys[0]].validations = [...dealValidations]
        console.log('spreadJson', spreadJson)

        this.spread.fromJSON(spreadJson)
      })
    },

    /**
     * @description 初始化表格校验规则
     */
    async initCellValid() {
      const spreadJson = defaultJson
      const sheetsKeys = Object.keys(spreadJson.sheets)
      if (!sheetsKeys.length) return
      const tables = spreadJson.sheets[sheetsKeys[0]].tables // 新建的表
      const addValidations = [] // 需要添加的校验规则
      const enumList = []

      // 当前是无模板实体，只会有一张表
      _.forEach(tables, (table) => {
        const columns = table.columns // 该表下的字段

        _.forEach(columns, (column, colIndex) => {
          const columnItem = _.find(this.columns, (item) => {
            return item.attributeName === column.name
          })
          if (columnItem) {
            // 不考虑多规则叠加
            if (columnItem.isNullable) {
              // 必填
              if (columnItem.valueType === 1) {
                // 最大长度限制
                addValidations.push(this.getExcelRule(1, colIndex, 5, columnItem.length))
              } else {
                addValidations.push(this.getExcelRule(1, colIndex, 1))
              }
            } else if (columnItem.valueType === 1) {
              // 最大长度限制
              addValidations.push(this.getExcelRule(1, colIndex, 4, columnItem.length))
            } else if (columnItem.valueType === 2) {
              // 整数
              addValidations.push(this.getExcelRule(1, colIndex, 2))
            } else if (columnItem.valueType === 3) {
              // 小数
              addValidations.push(this.getExcelRule(1, colIndex, 3))
            } else if (columnItem.valueType === 6) {
              // 日期时间
              column.dataStyle = {
                borderBottom: { color: '#7bafdd', style: 1 },
                borderTop: { color: '#7bafdd', style: 1 },
                formatter: 'YYYY-MM-DD hh:mm:ss',
              }
            } else if (columnItem.valueType === 8) {
              // 日期
              column.dataStyle = {
                borderBottom: { color: '#7bafdd', style: 1 },
                borderTop: { color: '#7bafdd', style: 1 },
                formatter: 'yyyy-mm-dd;@',
              }
            } else if (columnItem.valueType === 9) {
              // 时间
              column.dataStyle = {
                borderBottom: { color: '#7bafdd', style: 1 },
                borderTop: { color: '#7bafdd', style: 1 },
                formatter: 'h:mm:ss;@',
              }
            }
            if (columnItem.referenceDataClassId) {
              // 枚举数据限制
              enumList.push(
                (async () => {
                  const res = await StandardManagementService.getDataItem({
                    SkipCount: 0,
                    MaxResultCount: 99,
                    cateId: columnItem.referenceDataClassId,
                  })
                  if (res && res.data && res.code === 0) {
                    addValidations.push(
                      this.getExcelRule(1, colIndex, 6, 0, _.map(res.data, 'name').join(','))
                    )
                  }
                })()
              )
            }
            if (columnItem.symbol) {
              // 添加单位
              column.dataStyle = {
                borderBottom: { color: '#7bafdd', style: 1 },
                borderTop: { color: '#7bafdd', style: 1 },
                formatter: `#"${columnItem.symbol}"`,
              }
            }
          }
        })
      })

      await Promise.all(enumList)
      spreadJson.sheets[sheetsKeys[0]].validations = addValidations
      // this.spread.fromJSON(spreadJson)
      const sheet = this.spread.getActiveSheet()
      // sheet.options.isProtected = true // 禁止编辑
    },

    /**
     * @description 获取每个字段规则对应的excel规则
     * @param {Number} rowIndex 对应的行数
     * @param {Number} colIndex 对应的列数
     * @param {Number} type 字段规则类型 1: 必填 2：整数 3：小数 4：字符长度限制 5: 必填并且有字符长度限制 6:枚举限制
     * @param {Number} length 字符长度
     * @param {*} limitStr 限制规则
     * @returns 对应的excel规则
     */
    getExcelRule(rowIndex, colIndex, type, length, limitStr) {
      const excelRule = {
        errorTitle: '字段校验',
        condition: {},
        highlightStyle: '{"type":1,"color":"#FF0000","position":1}',
        ranges: `${this.getColumnLetter(colIndex)}${rowIndex + 1}`,
      }
      if (type === 1) {
        excelRule.comparisonOperator = 3
        excelRule.condition = {
          compareType: 3,
          conType: 7,
          expected: '1',
          ignoreBlank: true,
          ranges: [
            {
              row: rowIndex,
              col: colIndex,
              rowCount: 1,
              colCount: 1,
            },
          ],
        }
        excelRule.type = 6
        excelRule.errorMessage = '当前项为必填项'
        excelRule.inputMessage = '当前项为必填项'
      } else if (type === 2) {
        excelRule.comparisonOperator = 3
        excelRule.condition = {
          compareType: 3,
          conType: 1,
          expected: '',
          ignoreBlank: true,
          integerValue: true,
          ranges: [
            {
              row: rowIndex,
              col: colIndex,
              rowCount: 1,
              colCount: 1,
            },
          ],
        }
        excelRule.type = 1
        excelRule.errorMessage = '当前项数据必须为整数'
        excelRule.inputMessage = '当前项数据必须为整数'
      } else if (type === 3) {
        excelRule.comparisonOperator = 3
        excelRule.condition = {
          compareType: 3,
          conType: 1,
          expected: '',
          ignoreBlank: true,
          ranges: [
            {
              row: rowIndex,
              col: colIndex,
              rowCount: 1,
              colCount: 1,
            },
          ],
        }
        excelRule.type = 2
        excelRule.errorMessage = '当前项数据必须为小数'
        excelRule.inputMessage = '当前项数据必须为小数'
      } else if (type === 4) {
        excelRule.comparisonOperator = 5
        excelRule.condition = {
          compareType: 5,
          conType: 7,
          expected: `${length}`,
          ignoreBlank: true,
          ranges: [
            {
              row: rowIndex,
              col: colIndex,
              rowCount: 1,
              colCount: 1,
            },
          ],
        }
        excelRule.type = 6
        excelRule.errorMessage = `当前项数据字符长度不能超过${length}`
        excelRule.inputMessage = `当前项数据字符长度不能超过${length}`
      } else if (type === 5) {
        excelRule.condition = {
          compareType: 1,
          conType: 0,
          ignoreBlank: true,
          item1: {
            compareType: 3,
            conType: 7,
            expected: '1',
            ranges: [
              {
                row: rowIndex,
                col: colIndex,
                rowCount: 1,
                colCount: 1,
              },
            ],
          },
          item2: {
            compareType: 5,
            conType: 7,
            expected: `${length}`,
            ranges: [
              {
                row: rowIndex,
                col: colIndex,
                rowCount: 1,
                colCount: 1,
              },
            ],
          },
          ranges: [
            {
              row: rowIndex,
              col: colIndex,
              rowCount: 1,
              colCount: 1,
            },
          ],
        }
        excelRule.type = 6
        excelRule.errorMessage = `当前项为必填项，且数据字符长度不能超过${length}`
        excelRule.inputMessage = `当前项为必填项，且数据字符长度不能超过${length}`
      } else if (type === 6) {
        // const sheet = this.spread.getActiveSheet()
        // const rowCount = sheet.getRowCount()
        excelRule.condition = {
          conType: 12,
          expected: limitStr,
          ignoreBlank: true,
          ranges: [
            {
              row: rowIndex,
              col: colIndex,
              rowCount: 1,
              colCount: 1,
            },
          ],
        }
        excelRule.type = 3
        excelRule.errorMessage = '当前项数据必须是枚举类型之一'
        excelRule.inputMessage = '当前项数据必须是枚举类型之一'
      }
      return excelRule
    },

    /**
     * @description 根据列索引获取对应的英文列索引
     * @param {Number} colIndex 列索引
     * @returns 对应的英文列索引
     */
    getColumnLetter(colIndex) {
      let temp
      let letter = ''
      while (colIndex >= 0) {
        temp = colIndex % 26
        letter = String.fromCharCode(temp + 65) + letter // 65 是 'A' 的 ASCII 值
        colIndex = Math.floor(colIndex / 26) - 1
      }
      return letter
    },
    classTreeMouseOver(node) {
      const offsetWidth = document.querySelector(`.${node}`).offsetWidth
      const clientWidth = document.querySelector(`.${node}`).parentNode.clientWidth
      if (offsetWidth <= clientWidth) {
        this.isShowTooltip = true
      } else {
        this.isShowTooltip = false
      }
    },
    async handleNodeClick(data) {
      this.nodeClick = true
      this.currentClassName = ''
      this.currentNode = data
      this.currentTempData = null
      this.currentTempDataId = ''
      await this.getTempData()

      if (!data.templateId && data.dataType === 2) {
        const parameter = {
          classId: this.currentNode?.id,
          standardId: this.standardId,
        }
        const res = await StandardManagementService.getEntityTree(parameter)
        if (res && res.data?.length && res.code === 0) {
          console.log(res.data, '0009999')
          this.currentClassName = res.data[0].className
          console.log(this.currentClassName, 'currentClassName')
          const attributeList = _.filter(res.data[0].attributeList, (i) => {
            return i.attributeCode !== 'ApproveStatus' // 排除审批状态列
          })
          defaultJson.sheets.Sheet1.tables[0].columns = _.map(attributeList, (i, index) => {
            return {
              id: index,
              name: i.attributeName,
              dataField: i.attributeName,
            }
          })
          this.columns = [...attributeList]
          defaultJson.sheets.Sheet1.tables[0].colCount =
            defaultJson.sheets.Sheet1.tables[0].columns.length
          defaultJson.sheets.Sheet1.tables[0].bindingPath = res.data[0].className
        }
        this.sheet = this.spread.getActiveSheet()
        defaultJson.sheets.Sheet1.columnCount = this.columns.length + 10 // 设置列数
        if (this.currentTempData) {
          const valueList = Object.values(this.currentTempData)
          defaultJson.sheets.Sheet1.rowCount = 50 + valueList[0].length // 设置列数
        } else {
          defaultJson.sheets.Sheet1.rowCount = 100 // 设置列数
        }
        defaultJson.highlightInvalidData = true
        await this.initCellValid()
        this.spread.fromJSON(defaultJson)
        this.initDataSource()
      } else {
        const parameter = {
          classId: this.currentNode?.id,
          standardId: this.standardId,
        }
        const entityRes = await StandardManagementService.getEntityTree(parameter)
        if (entityRes && entityRes.data?.length && entityRes.code === 0) {
          this.currentClassName = entityRes.data[0].className
          console.log(this.currentClassName, 'currentClassName')
        }
        const res = await StandardManagementService.getTemplateData({
          id: this.currentTempDataId,
        })
        if (res && res.code === 0) {
          if (res.data?.context) {
            const context = JSON.parse(res.data.context)
            console.log(context, 'context')
            context.sheets.Sheet1.rowCount = 100
            context.sheets.Sheet1?.tables?.forEach((tableItem) => {
              tableItem.rowCount = 100
            })
            console.log(context.sheets.Sheet1.tables, 'tables')
            this.defineParasList = JSON.parse(res.data.defineParas)
            await this.addFieldRuleByTable({ ...context })
            this.spread.fromJSON(context)
            console.log(this.spread.toJSON(), 'json')
          } else {
            this.spread.fromJSON('{}')
          }
          // const sheet = this.spread.getActiveSheet()
          // sheet.options.isProtected = true // 禁止编辑
        }
        this.saveSuceess = false

        this.initDataSource()
      }
    },

    /**
     * @description 获取实体树
     */
    async getEntityTree() {
      this.treeLoading = true
      const res = await StandardManagementService.getEntityTreeData({ standardId: this.standardId })
      this.treeLoading = false
      this.treeData = res || []
    },

    // 获取标准库
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = res.data
        this.standardId = this.standardList[0]?.id
      }
    },
    searchEntity() {
      this.$refs.tree.filter(this.entityContent)
    },
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },

    /**
     * @description 临时数据暂存
     */
    async scratchpadTableData() {
      if (!this.currentNode?.id) return
      const sheet = this.spread.getActiveSheet()
      this.spreadjsLoading = true
      const res = await StandardManagementService.collectTempData({
        classId: this.currentNode.id,
        templateId: this.currentTempDataId || null,
        collectUserId: this.userInfo?.profile?.sub,
        tempData: sheet.getDataSource() ? JSON.stringify(sheet.getDataSource().getSource()) : '',
      })
      this.spreadjsLoading = false
      if (res && res.code === 0) {
        this.currentTempDataId = res.data?.id
        this.$message.success('成功')
      }
    },

    /**
     * @description 清除暂存数据
     */
    deleteTempData() {
      if (!this.currentTempDataId) return
      this.$confirm('是否确定要删除该实体的暂存数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await StandardManagementService.deleteTempData({
          id: this.currentTempDataId,
        })
        if (res && res.code === 0) {
          this.$message.success('删除成功')
          this.handleNodeClick(this.currentNode)
        }
      })
    },

    /**
     * @description 临时数据查询
     */
    async getTempData() {
      if (!this.currentNode?.id) return
      this.spreadjsLoading = true
      const res = await StandardManagementService.geEntitytList({
        className: this.currentNode.name,
        standardId: this.standardId,
      })
      this.spreadjsLoading = false
      if (res && res.data && res.code === 0) {
        // this.currentTempData = _.find(res.data, (item) => {
        //   return item.className === this.currentNode.name
        // })
        const currentTemp = _.find(res.data, (item) => {
          return item.className === this.currentNode.name
        })
        await this.getTempDataById(currentTemp?.templateId)
        this.currentTempDataId = currentTemp.templateId
      }
    },

    async getTempDataById(templateId) {
      const res = await StandardManagementService.getTempData({
        classId: this.currentNode.id,
        templateId: templateId || null,
        collectUserId: this.userInfo?.profile?.sub,
      })
      if (res && res.data && res.code === 0) {
        this.currentTempData = JSON.parse(res.data.tempData)
        this.currentTempDataId = res.data.id
      }
    },

    down(blob, excelName) {
      const url = window.URL.createObjectURL(blob)
      // 创建隐藏的可下载链接
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', `${excelName}.xlsx`)
      document.body.appendChild(link)
      link.click()
    },
    initSheet() {
      const config = { ...GC.Spread.Sheets.Designer.DefaultConfig }
      // 创建自定义按钮
      config.commandMap = {
        export: {
          title: '自定义命令',
          text: '导出',
          bigButton: 'true',
          iconClass: 'iconfont icon-line-download',
          commandName: 'export',
          execute: () => {
            const json = this.spread.toJSON()
            this.spreadjsLoading = true
            this.excelIo.save(
              json,
              (blob) => {
                this.down(
                  blob,
                  `${this.currentNode?.name || ''}${dayjs().format('YYYY-MM-DD HH:mm:ss')}`
                )
              },
              () => {}
            )
            this.spreadjsLoading = false
          },
        },
        create: {
          title: '自定义命令',
          text: '新增',
          bigButton: 'true',
          iconClass: 'iconfont icon-line-add',
          commandName: 'create',
          execute: () => {
            const sheet = this.spread.getActiveSheet()
            sheet.options.isProtected = false // 禁止编辑
          },
        },
        edit: {
          title: '自定义命令',
          text: '编辑',
          bigButton: 'true',
          iconClass: 'iconfont icon-line-edit',
          commandName: 'edit',
          execute: () => {
            // this.sheet.options.isProtected = false
            const sheet = this.spread.getActiveSheet()
            sheet.options.isProtected = false // 禁止编辑
          },
        },
        review: {
          title: '自定义命令',
          text: '提交',
          bigButton: 'true',
          iconClass: 'iconfont icon-line-send',
          commandName: 'review',
          execute: async () => {
            this.insertCollectData()
          },
        },
        saveTemplate: {
          title: '自定义命令',
          text: '暂存',
          bigButton: 'true',
          iconClass: 'iconfont icon-line-files',
          commandName: 'saveTemplate',
          execute: async () => {
            this.scratchpadTableData()
          },
        },
        deleteTempData: {
          title: '自定义命令',
          text: '清除暂存数据',
          bigButton: 'true',
          iconClass: 'iconfont icon-line-files',
          commandName: 'deleteTempData',
          execute: async () => {
            this.deleteTempData()
          },
        },
      }
      const customTab = {
        id: 'customTab',
        text: '采集功能',
        buttonGroups: [
          {
            commandGroup: {
              children: [
                {
                  direction: 'horizontal',
                  commands: ['export', 'review', 'saveTemplate', 'deleteTempData'],
                },
              ],
            },
          },
        ],
      }
      config.ribbon = _.uniqBy([...config.ribbon, customTab], 'id')
      const designer = new GC.Spread.Sheets.Designer.Designer(
        document.getElementById('gc-designer-box'),
        config
      )
      this.designer = designer
      this.spread = designer.getWorkbook()
      this.excelIo = new GC.Spread.Excel.IO()
      this.sheet = this.spread.getActiveSheet()
      this.sheet
        .getRange(0, 0, this.sheet.getRowCount(), this.sheet.getColumnCount())
        .hAlign(GC.Spread.Sheets.HorizontalAlign.center)
      this.sheet
        .getRange(0, 0, this.sheet.getRowCount(), this.sheet.getColumnCount())
        .vAlign(GC.Spread.Sheets.VerticalAlign.center)
      this.sheet.options.allowUserResize = true
      this.sheet.options.protectionOptions = {
        allowResizeRows: true,
        allowResizeColumns: true,
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.el-tree {
  height: calc(100% - 150px);
  overflow: auto;
}
.el-tree-node__content {
  height: auto;
}
::v-deep .fileButton {
  display: none;
}
::v-deep .el-tree-node__content {
  height: 40px;
}

</style>
